import React from 'react';
import clsx from 'clsx';
import '@/blocks/AccreditationBlock/AccreditationBlock.styles.css';
import { IAccreditationCardProps, IProps } from '@/blocks/AccreditationBlock/AccreditationBlock.interface';
import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, {
    ContentColumn,
} from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import Text from '@/elements/Text/Text.component';
import Button from '@/elements/Button/Button.component';
import Image from '@/elements/Image/Image.component';



const FeatureLinksIconsCard = (card: IAccreditationCardProps) => {
    const { cardType, description, heading, image } = card;
    return (
        <div
            className={clsx(
                'accreditationBlock__card',
                `accreditationBlock__card--${cardType}`,
            )}
            role="listitem"
        >
            {image && (
                <div className="accreditationBlock__card-image-container">
                    <Image
                        {...image}
                        className="accreditationBlock__card-image"
                    />
                </div>
            )}

            <div className="accreditationBlock__card-content">
                {heading && (
                    <Heading
                        level={3}
                        className="accreditationBlock__card-heading"
                        html={heading}
                    />
                )}
                {description && (
                    <Text
                        className="accreditationBlock__card-description"
                        html={description}
                    />
                )}
            </div>
        </div>
    );
};

export const AccreditationBlock: React.FC<IProps> = (props) => {
    const {
        heading,
        description,
        cards,
        cardType,
        className,
        ...blockWrapperProps
    } = props;

    // Responsive: On mobile, always horizontal and 1 column
    // Use CSS for layout switching

    return (
        <BlockWrapper
            className={clsx('accreditationBlock', className)}
            {...blockWrapperProps}
        >
            <ContentWrapper>
                <ContentColumn>
                    <div className="accreditationBlock__header">
                        {heading && (
                            <Heading
                                level={2}
                                className="accreditationBlock__heading"
                                html={heading}
                            />
                        )}
                    </div>
                    {description && (
                        <Text
                            className="accreditationBlock__description"
                            html={description}
                        />
                    )}
                    <div
                        className={clsx(
                            'accreditationBlock__cards',
                            `accreditationBlock__cards--${cardType}`,
                        )}
                        role="list"
                    >
                        {cards.map((card, idx) => (
                            <FeatureLinksIconsCard
                                key={`accreditation-blokc-card-${idx}`}
                                {...card}
                                cardType={cardType}
                            />
                        ))}
                    </div>
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};
